module.exports = __webpack_public_path__ + "img/credit-card.dc33044b.svg";